<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <div class="customButton" v-for="(item,index) in dateQuery" :key="index" @click="switchSelection(index)"
             :class="butonStart === index ? 'border-end':''">{{item.name}}</div>
        <el-date-picker v-model="timeSrc" :type="type" :value-format="valueFormat" @change="getList()" :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" class="elm-but" @click="reset" style="margin-left: 8px;">重置
        </el-button>
      </div>
      <div>
        <table class="surface">
          <thead>
            <tr>
              <th>告警类型</th>
              <th>告警工单总数</th>
<!--              <th>草稿工单数</th>-->
<!--              <th>未指派工单数</th>-->
              <th>正在处理工单数</th>
<!--              <th>疑难工单数</th>-->
<!--              <th>复核工单数</th>-->
              <th>完成工单数</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in data" :key="index">
              <td>{{item.typeName}}</td>
              <td>{{item.total}}</td>
<!--              <td>{{item.drafts}}</td>-->
<!--              <td>{{item.unassigned}}</td>-->
              <td>{{item.processing}}</td>
<!--              <td>{{item.unableprocess}}</td>-->
<!--              <td>{{item.review}}</td>-->
              <td>{{item.completed}}</td>
            </tr>
          </tbody>
          <noData :data="data" />
        </table>
        <el-pagination
          background
          style="text-align: center;margin-top:15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum "
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";
export default {
  components: {noData},
  data() {
    return {
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      total: 0,
      data: null,
      loading: false,
      timeSrc: "",  //日期请求参数
      type: "year",
      valueFormat: "yyyy",
      dateQuery: [{ name: "年", },{ name: "月", },{ name: "日", },],
      butonStart: 0, //日期按钮
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如
        },
      },
    };
  },
  methods: {
    getList() {
      this.loading = true;
      this.get("operation/management/selectIssueWorkOrderList", {
        timeSrc: this.timeSrc,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }).then((res) => {
        this.data = res.data.rows;
        this.total = res.data.total;
        this.loading = false;
      });
    },

    //日期按钮点击切换
    switchSelection(index) {
      this.butonStart = index;
      this.timeSrc = null;
      if (this.butonStart == 0) {
        this.type = "year"
        this.valueFormat = "yyyy"
        this.timeSrc = new Date().getFullYear().toString();
      } else if (this.butonStart == 1) {
        this.type = "month"
        this.valueFormat = "yyyy-MM"
        this.timeSrc = this.global.date('month')
      } else {
        this.type = "date"
        this.valueFormat = "yyyy-MM-dd"
        this.timeSrc = this.global.date('date')
      }
      this.getList();
    },

    //重置
    reset() {
      this.butonStart = 0;
      this.type = "year",
        this.valueFormat = "yyyy",
        this.timeSrc = new Date().getFullYear().toString();
      this.getList();
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },
    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
  },
  mounted() {
    this.getList();
    this.timeSrc = new Date().getFullYear().toString();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/menu/statisticalReport/workorderSummaryReport.vue